import React from 'react'
import { graphql } from 'gatsby'
import PropTypes from 'prop-types'
import { Form, Field } from 'react-final-form'
import { OnChange } from 'react-final-form-listeners'
import { FormWrapper,
  Label,
  Input,
  Dropdown,
  TextArea,
  Submit,
  Checkbox,
  ErrorMessage } from '../../../styles/form'
import { ButtonArrow } from '../../../shared/Buttons/Buttons.styles'
// import { FormField } from './ContactForm.style'
import ArrowDown from '../Icons/ArrowDown'
import ArrowRight from '../Icons/ArrowRight'
import { isEmailValid,
  composeValidators,
  required,
  // isValidJPNumber,
  // isKanji,
  isFurigana,
  isValidName } from '../../../utils/validators'

import { ENQUIRY_FIELD_LABEL,
  // CATEGORY_SELECT_PLACEHOLDER,
  KANJI_NAME_FIELD_LABEL,
  FURIGANA_NAME_FIELD_LABEL,
  EMAIL_FIELD_LABEL,
  EMAIL_FIELD_PLACEHOLDER,
  // PHONE_NO_FIELD_LABEL,
  // PHONE_NO_FIELD_PLACEHOLDER,
  CONTACT_SUBMIT_BTN_LABEL,
  PRIVACY_POLICY_LABEL,
  CONFIRM_CHECKBOX_LABEL,
  PRIVACY_POLICY_CONFIRM_LABEL,
  NEWSLETTER_SUBSCRIBE_LABEL,
  CHOOSE_AN_OPTION,
  PARTNERSHIP_AND_LICENSING,
  HARDWARE,
  BROADCASTING,
  APP,
  OTHER,
  STREAMING,
  PRESS_MEDIA,
  USER_LISTENER,
  COMPANY_NAME_LABEL,
  POSITION_LABEL } from '../../../locales'
import { encode } from '../../../utils/siteHelper'

const Condition = ({ when, is, children }) => (
  <Field
    name={when}
    subscription={{
      value: true,
    }}
  >
    {({ input: { value } }) => (is(value) ? children : null)}
  </Field>
)

Condition.propTypes = {
  when: PropTypes.string.isRequired,
  is: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
}

const endpoints = {
  [PARTNERSHIP_AND_LICENSING]: 'https://mqa.us11.list-manage.com/subscribe/post?u=79342aa8e374e32ed2c802400&amp;id=0a963114d7',
  [PRESS_MEDIA]: 'https://mqa.us11.list-manage.com/subscribe/post?u=79342aa8e374e32ed2c802400&amp;id=ec0ff5ac0e',
  [USER_LISTENER]: 'https://mqa.us11.list-manage.com/subscribe/post?u=79342aa8e374e32ed2c802400&amp;id=a4039ad0bf',
  [OTHER]: 'https://mqa.us11.list-manage.com/subscribe/post?u=79342aa8e374e32ed2c802400&amp;id=55230664a4',
}

const dropdownItems = Object.keys(endpoints)
const partnerDropdownItems = [
  {
    label: HARDWARE, value: 'Hardware',
  },
  {
    label: STREAMING, value: 'JP - Streaming + Record label + Download',
  },
  {
    label: BROADCASTING, value: 'Broadcast',
  },
  {
    label: APP, value: 'JP - App',
  },
  {
    label: OTHER, value: 'JP - Other',
  },
]
class ContactForm extends React.Component {
  state = {
    action: '',
  }

  form = React.createRef()

  handleSubmit = async values => {
    // const { thankYouPageLink } = this.props
    // console.log(values)

    fetch('/?no-cache=1', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: encode({
        'form-name': 'contact',
        ...values,
      }),
    })
      .then(() => {
        this.form.current.submit()
      })
      /* eslint-disable-next-line */
      .catch(error => console.log(error))
  }

  render() {
    const {
      enableCategoryDropdown,
      // dropdownItems,
      submitButtonLabel,
      privacyPolicyPageLink,
    } = this.props

    const { action } = this.state

    return (
      <>
        <form
          name="contact"
          data-netlify="true"
          data-netlify-honeypot="bot"
          hidden
        >
          <input name="bot" id="bot" />
          <input name={CHOOSE_AN_OPTION} />
          <input name="MMERGE5" />
          <input name="EMAIL" />
          <input name="FNAME" />
          <input name="PRONOUNCE" />
          <input name="MMERGE6" />
          <input name="CNAME" />
          <input name="POSITION" />
          <input name={ENQUIRY_FIELD_LABEL} />
        </form>
        <Form
          onSubmit={this.handleSubmit}
          enableCategoryDropdown={enableCategoryDropdown}
          // dropdownItems={dropdownItems}
          initialValues={{
            [NEWSLETTER_SUBSCRIBE_LABEL]: false,
          }}
          render={({ handleSubmit, pristine, invalid }) => (
            <FormWrapper
              name="contact"
              onSubmit={handleSubmit}
              action={action}
              method="post"
              ref={this.form}
            >
              <p hidden>
                <label htmlFor="bot">
                Don’t fill this out:
                  <Field
                    name="bot"
                  >
                    {({ input }) => (
                      <input
                        {...input}
                        type="text"
                        hidden
                        aria-hidden
                      />
                    )}
                  </Field>
                </label>
              </p>

              <Field name={CHOOSE_AN_OPTION} validate={required}>
                {({ input, meta }) => (
                  <Dropdown>
                    <select
                      {...input}
                      aria-label={CHOOSE_AN_OPTION}
                    >
                      <option value="" disabled>
                        {CHOOSE_AN_OPTION}
                      </option>
                      {dropdownItems.map((item, index) => {
                        return (
                          <option key={item} value={item}>
                            {item}
                          </option>
                        )
                      })}
                    </select>
                    <svg viewBox="0 0 21 12">
                      <ArrowDown />
                    </svg>
                    {meta.error && meta.touched && (
                      <ErrorMessage>{meta.error}</ErrorMessage>
                    )}
                  </Dropdown>
                )
                }
              </Field>

              <OnChange name={CHOOSE_AN_OPTION}>
                {(val) => {
                  const action = endpoints[val]
                  // console.log(action)

                  this.setState({
                    action,
                  })
                }}
              </OnChange>

              <Condition when={CHOOSE_AN_OPTION} is={(value) => (value === PARTNERSHIP_AND_LICENSING)}>
                <Field name="MERGE5" validate={required}>
                  {({ input, meta }) => (
                    <Dropdown>
                      <select
                        {...input}
                        aria-label={PARTNERSHIP_AND_LICENSING}
                      >
                        <option value="" disabled>
                          {CHOOSE_AN_OPTION}
                        </option>
                        {partnerDropdownItems.map((item) => {
                          return (
                            <option key={item.value} value={item.value}>
                              {item.label}
                            </option>
                          )
                        })}
                      </select>
                      <svg viewBox="0 0 21 12">
                        <ArrowDown />
                      </svg>
                      {meta.error && meta.touched && (
                        <ErrorMessage>{meta.error}</ErrorMessage>
                      )}
                    </Dropdown>
                  )
                  }
                </Field>
              </Condition>

              <Condition when={CHOOSE_AN_OPTION} is={(value) => (dropdownItems.includes(value))}>
                <Field
                  name="EMAIL"
                  validate={composeValidators(required, isEmailValid)}
                >
                  {({ input, meta }) => (
                    <div>
                      <Label htmlFor={EMAIL_FIELD_LABEL}>{EMAIL_FIELD_LABEL}</Label>
                      <Input
                        {...input}
                        type="email"
                        aria-label={EMAIL_FIELD_PLACEHOLDER}
                        placeholder={EMAIL_FIELD_PLACEHOLDER}
                      />
                      {meta.error && meta.touched && (
                        <ErrorMessage>{meta.error}</ErrorMessage>
                      )}
                    </div>
                  )}
                </Field>

                <Field
                  name="FNAME"
                  validate={composeValidators(required, isValidName)}
                >
                  {({ input, meta }) => (
                    <div>
                      <Label htmlFor={KANJI_NAME_FIELD_LABEL}>
                        {KANJI_NAME_FIELD_LABEL}
                      </Label>
                      <Input
                        {...input}
                        type="text"
                        placeholder={KANJI_NAME_FIELD_LABEL}
                        maxLength="40"
                        aria-label={KANJI_NAME_FIELD_LABEL}
                      />
                      {meta.error && meta.touched && (
                        <ErrorMessage>{meta.error}</ErrorMessage>
                      )}
                    </div>
                  )}
                </Field>

                <Field
                  name="PRONOUNCE"
                  validate={composeValidators(required, isFurigana)}
                >
                  {({ input, meta }) => (
                    <div>
                      <Label htmlFor={FURIGANA_NAME_FIELD_LABEL}>
                        {FURIGANA_NAME_FIELD_LABEL}
                      </Label>
                      <Input
                        {...input}
                        type="text"
                        placeholder={FURIGANA_NAME_FIELD_LABEL}
                        aria-label={FURIGANA_NAME_FIELD_LABEL}
                        maxLength="40"
                      />
                      {meta.error && meta.touched && (
                        <ErrorMessage>{meta.error}</ErrorMessage>
                      )}
                    </div>
                  )}
                </Field>

                <Condition when={CHOOSE_AN_OPTION} is={value => (value !== USER_LISTENER)}>
                  <Field
                    name={action === endpoints[PRESS_MEDIA] ? 'MMERGE6' : 'CNAME'}
                    validate={action === endpoints[PARTNERSHIP_AND_LICENSING] ? composeValidators(required) : () => undefined}
                    key={action}
                  >
                    {({ input, meta }) => (
                      <div>
                        <Label htmlFor={COMPANY_NAME_LABEL}>
                          {COMPANY_NAME_LABEL}
                        </Label>
                        <Input
                          {...input}
                          type="text"
                          placeholder={COMPANY_NAME_LABEL}
                          aria-label={COMPANY_NAME_LABEL}
                          maxLength="40"
                        />
                        {meta.error && meta.touched && (
                          <ErrorMessage>{meta.error}</ErrorMessage>
                        )}
                      </div>
                    )}
                  </Field>

                  <Field
                    name="POSITION"
                    key={action + '0'}
                  >
                    {({ input, meta }) => (
                      <div>
                        <Label htmlFor={POSITION_LABEL}>
                          {POSITION_LABEL}
                        </Label>
                        <Input
                          {...input}
                          type="text"
                          placeholder={POSITION_LABEL}
                          aria-label={POSITION_LABEL}
                          maxLength="40"
                        />
                        {meta.error && meta.touched && (
                          <ErrorMessage>{meta.error}</ErrorMessage>
                        )}
                      </div>
                    )}
                  </Field>
                </Condition>

                <Field name={ENQUIRY_FIELD_LABEL}>
                  {({ input, meta }) => (
                    <div>
                      <Label htmlFor={ENQUIRY_FIELD_LABEL}>
                        {ENQUIRY_FIELD_LABEL}
                      </Label>
                      <TextArea
                        {...input}
                        type="text"
                        maxLength="255"
                        aria-label={ENQUIRY_FIELD_LABEL}
                      />
                      {meta.error && meta.touched && (
                        <ErrorMessage>{meta.error}</ErrorMessage>
                      )}
                    </div>
                  )}
                </Field>

                <Field name={PRIVACY_POLICY_CONFIRM_LABEL} validate={required}>
                  {({ input, meta }) => (
                    <Checkbox>
                      <Input
                        {...input}
                        type="checkbox"
                        id={PRIVACY_POLICY_CONFIRM_LABEL}
                      />
                      <Label htmlFor={PRIVACY_POLICY_CONFIRM_LABEL}>
                        <a
                          href={'../' + privacyPolicyPageLink.slug}
                          rel="noopener noreferrer"
                          target="_blank"
                        >
                          {PRIVACY_POLICY_LABEL}
                        </a>
                        {CONFIRM_CHECKBOX_LABEL}
                      </Label>
                      {meta.error && meta.touched && (
                        <ErrorMessage>{meta.error}</ErrorMessage>
                      )}
                    </Checkbox>
                  )}
                </Field>

                <Field name={NEWSLETTER_SUBSCRIBE_LABEL}>
                  {({ input, meta }) => (
                    <Checkbox>
                      <Input
                        {...input}
                        type="checkbox"
                        id={NEWSLETTER_SUBSCRIBE_LABEL}
                      />
                      <Label htmlFor={NEWSLETTER_SUBSCRIBE_LABEL}>
                        {NEWSLETTER_SUBSCRIBE_LABEL}
                      </Label>
                      {meta.error && meta.touched && (
                        <ErrorMessage>{meta.error}</ErrorMessage>
                      )}
                    </Checkbox>
                  )}
                </Field>

                <Submit>
                  <button type="submit">
                    {submitButtonLabel}
                    <ButtonArrow viewBox="0 0 12 21">
                      <ArrowRight />
                    </ButtonArrow>
                  </button>
                </Submit>
              </Condition>
            </FormWrapper>
          )}
        />
      </>
    )
  }
}

ContactForm.propTypes = {
  enableCategoryDropdown: PropTypes.bool.isRequired,
  dropdownItems: PropTypes.arrayOf(String),
  submitButtonLabel: PropTypes.string,
  thankYouPageLink: PropTypes.shape({
    slug: PropTypes.string,
  }).isRequired,
  privacyPolicyPageLink: PropTypes.shape({
    slug: PropTypes.string,
  }).isRequired,
}

ContactForm.defaultProps = {
  dropdownItems: [],
  submitButtonLabel: CONTACT_SUBMIT_BTN_LABEL,
}

export default ContactForm

export const ContactFormFragment = graphql`
  fragment ContactFormFragment on ContentfulContactForm {
    enableCategoryDropdown
    dropdownItems
    submitButtonLabel
    thankYouPageLink {
      slug
    }
    privacyPolicyPageLink {
      slug
    }
  }
`
